import React from "react";
import "./Terms.scss";

const Terms = ({ setShowTerms, termsContent, textColor, buttonColor }) => {
  const containerStyle = {
    color: textColor || undefined,
  };

  return (
    <div className="Terms" style={containerStyle}>
      <div className="terms-header">
        <button
          className="back-button"
          onClick={() => setShowTerms(false)}
          style={{ color: textColor }}
        >
          ← Back to Game
        </button>
        <h2 style={{ color: textColor }}>Terms & Conditions</h2>
      </div>

      <div className="terms-content">
        {termsContent ? (
          <>
            <div
              dangerouslySetInnerHTML={{ __html: termsContent }}
              className="terms-content-text"
            />
            <button
              onClick={() => setShowTerms(false)}
              className="Button agree"
              style={{ backgroundColor: buttonColor }}
            >
              Agree
            </button>
          </>
        ) : (
          <p>No terms and conditions have been set for this game.</p>
        )}
      </div>
    </div>
  );
};

export default Terms;
